jQuery(document).ready(function(jQuery) {

    var has_green_banner = jQuery('.hero-banner').closest('.gt-section');
    if( jQuery(has_green_banner).hasClass('bg-green') == true ) {
       jQuery('header').addClass('green-header');
    }
    else if( jQuery(has_green_banner).hasClass('bg-blue') == true ) {
        jQuery('header').addClass('blue-header');
    }

    // for the mob menu
    $( ".navbar-nav .submenu-opener" ).on('click', function( e ) {
        e.preventDefault();

        if ( !$( this ).hasClass( 'closed' ) ) {
            $( this ).addClass( 'closed' );
            $( this ).next('ul.dropdown-menu').css('display', 'block');
        }
        else {
            $( this ).removeClass( 'closed' );
            $( this ).next('ul.dropdown-menu').css('display', 'none');
        }

    });

    jQuery('.navbar').on('click', '.navbar-toggler', function (e){
        e.preventDefault();
        if(!jQuery(this).hasClass("nav-open")) {
            jQuery('#navbar').removeClass('active');
            jQuery('body').removeClass('menu-active');
            jQuery(this).removeClass('nav-close').addClass('nav-open');
            //         jQuery('header').removeClass('nav-close').addClass('nav-open');

        } else {
            jQuery('#navbar').addClass('active');
            jQuery('body').addClass('menu-active');
            jQuery(this).removeClass('nav-open').addClass('nav-close');
        }
    });

    $(window).scroll(function(){
        var sticky = $('header'),
            scroll = $(window).scrollTop();

        if (scroll >= 3) sticky.addClass('fixed');
        else sticky.removeClass('fixed');
    });

    $('.hero-banner-slider').slick({
        infinite: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        prevArrow:"<div class='slick-arrow arrow-left'><i class='icon icon-arrow-left' aria-hidden='true'></i></div>",
        nextArrow:"<div class='slick-arrow arrow-right'><i class='icon icon-arrow-right' aria-hidden='true'></i></button>"
    });
    
});



function fixHeight(elem){
    var maxHeight = 0;
    $(elem).css('height','auto');
    $(elem).each(function(){
        if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    $(elem).height(maxHeight);
}

$(window).on('load resize', function(e) {
    var width = $(window).width();

    jQuery('.pricing-block').each(function () {
       var textBlock =  jQuery(this).find('.small-text-img-block').innerHeight();
       var listBlock =  jQuery(this).find('.pricing-features').innerHeight();
       var listBlockTitle =  jQuery(this).find('.pricing-features h4').innerHeight();
       var listBlockText =  jQuery(this).find('.pricing-features p').innerHeight();
       var div_padding = parseInt(jQuery(this).css('padding-bottom').replace('px',''));

       var tHeight = textBlock + div_padding;
       var ulMargin = listBlockTitle + listBlockText;

        if ( width >= 768 ) {
            jQuery(this).find('.pricing-features').css("height",'calc(100% - '+tHeight+'px)');
        }

        else {
            jQuery(this).find('.pricing-features').css("height","auto");
        }
    })

});



$(document).ready(function(){
  // Add smooth scrolling to all links
  $("a.smoothscroll").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
});